import React from 'react'
import Header from '../components/website-components/Header/Header'

export default function PageLayout(props) {
  return (<>
    <Header hideRating={props.hideRating} />
    <div className='main'>
      {props.children}
    </div>
  </>)
}
